export default __webpack_public_path__ + "25a52197af56aed5b8c36164d43b8662.svg";